<template>
  <div class="w-full flex flex-row justify-center">
    <div class="w-full flex flex-row max-w-xl">
      <vs-row>
        <vs-col class="p-0 " vs-w="12">
          <vs-tabs ref="tabs" class="dashboard-tabs" alignment="start" color="primary" v-model="activeIndex" :value="activeIndex">
            <vs-tab label="Início" :disabled="isAnonimous" @click="changeRoute" />
            <vs-tab label="Perfil" @click="changeRoute" />
            <vs-tab label="Vagas" @click="changeRoute" />
            <vs-tab label="Reuniões" @click="changeRoute" />
            <vs-tab label="Carreira" :data-badge="careerIsNew ? 'NOVO' : null" @click="changeRoute" />
            <vs-tab label="Configurações" @click="changeRoute" />
          </vs-tabs>
          <!--
            `duration` explicito: sem ele o Vue espera o evento de fim de
            transicao do navegador, que nao chega quando o elemento que sai nao
            tem mudanca visual efetiva a animar. A tela seguinte entao nunca
            monta -- a URL muda e o conteudo anterior fica congelado.
          -->
          <transition name="slide-fade" mode="out-in" :duration="450">
            <router-view class="dashboard-controll__wrapper"></router-view>
          </transition>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

// Tag "NOVO" da aba Carreira: fica para todo mundo até esta data e some sozinha.
const CAREER_NEW_UNTIL = new Date("2026-11-07T23:59:59-03:00");

export default {
  data: () => ({
    careerIsNew: Date.now() <= CAREER_NEW_UNTIL.getTime(),
    path: [
      "dashboard-info",
      "dashboard-profile-detail",
      "dashboard-vacancy",
      "dashboard-meeting",
      "dashboard-career",
      "dashboard-settings",
    ]
  }),
  watch: {
    '$route': {
      handler() {
        this.updateActiveIndex();
      },
      immediate: true
    }
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),

    activeIndex: {
      set(value) {
        this.$store.dispatch("updateTab", value);
      },
      get() {
        return this.$store.state.activeIndex;
      }
    },

    name: {
      get() {
        return this.basicInfo.name || "";
      }
    },

    recruteiBaseTalentIsEnabled() {
      return this.company.has_base_public && this.optimizelyIsEnabled();
    },

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },

    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    }
  },
  methods: {
    changeRoute() {
      const actualPath = this.$router.history.current.name;
      if (actualPath !== this.path[this.activeIndex]) {
        this.$router.push({
          name: this.path[this.activeIndex]
        });
      }
    },
    optimizelyIsEnabled() {
      const params = this.$router.history.current.params;

      return this.$optimizely.isFeatureEnabled("base_de_talentos", "", {
        slugs: params.company_label
      });
    },
    // No celular as abas rolam para o lado: traz a ativa para a área visível.
    scrollActiveTab() {
      const root = this.$refs.tabs && this.$refs.tabs.$el;
      const strip = root && root.querySelector(".con-ul-tabs");
      const active = root && root.querySelector(".vs-tabs--li.activeChild");
      if (!strip || !active || strip.scrollWidth <= strip.clientWidth) return;
      const target = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
      strip.scrollLeft = Math.max(0, target);
    },
    updateActiveIndex() {
      // /club é a Carreira aberta no clube (volta do pagamento).
      const currentName = this.$router.history.current.name;
      const currentPath = currentName === "dashboard-club" ? "dashboard-career" : currentName;
      const index = this.path.indexOf(currentPath);
      if (index !== -1) {
        this.activeIndex = index;
      }
      this.$nextTick(this.scrollActiveTab);
    }
  },
};
</script>

<style lang="scss">
.dashboard {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  color: white;
}

.dashboard--title {
  color: white;
  text-align: center;

  @media screen and (max-width: 578px) {
    font-size: 1.5em;
  }
}

// Seis abas não cabem no celular: a barra rola para o lado (sem barra de rolagem
// visível) e um esmaecido na borda direita mostra que tem mais.
.dashboard-tabs {
  position: relative;

  .con-ul-tabs {
    overflow-x: auto;
    overflow-y: hidden;
    // A linha da aba ativa fica logo abaixo das abas: sem esse respiro a rolagem a corta.
    padding-bottom: 3px;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .vs-tabs--ul {
    width: max-content;
    min-width: 100%;
  }

  @media (max-width: 767px) {
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 28px;
      height: 40px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);
      pointer-events: none;
    }
  }
}

// Aba "Início" escondida (10/2026): a tela continua existindo em dashboard/info, só sai do
// menu. Fica no DOM para não mudar o índice das outras abas (activeIndex e updateTab).
// Para voltar, apague esta regra.
.dashboard-tabs .vs-tabs--li:first-child {
  display: none;
}

// Tag "NOVO" na aba (o vs-tab repassa data-badge para o botão).
.vs-tabs--btn[data-badge]::after {
  content: attr(data-badge);
  display: inline-block;
  margin-left: 6px;
  padding: 2px 5px;
  border-radius: 4px;
  // Laranja de alerta do app (#ff5900, DESIGN.md do talento).
  background: #ff5900;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.04em;
  vertical-align: 2px;
}

.dashboard-controll__wrapper {
  max-width: 90%;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    max-width: 100%;
  }
}
</style>
